import { ActionButton } from "@components";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { LOCKED_FEATURES } from "@utils";
import { useFeatureGuardian } from "@hooks";
import { useEstimateEditorStore } from "@tools";
import { CircularProgress } from "@material-ui/core";
import { DollarSign } from "@assets";

export const ProfitabilityMode = observer(() => {
  
  const { t } = useTranslation();
  const editorStore = useEstimateEditorStore();
  
  const { checkAccess, isChecking, FeatureAlert } = useFeatureGuardian(
    LOCKED_FEATURES.PROFITABILITY
  );
  
  const { profitabilityMode } = editorStore;
  
  const handleProfitabilityMode = async () => {
    if(!profitabilityMode) {
      if(!editorStore.allowProfitability) {
        const allowed = await checkAccess();
        if(!allowed)
          return;
        editorStore.setAllowProfitability(allowed);
      }
    }
    await editorStore.switchProfitabilityMode();
  };
  
  return (
    <>
      <ActionButton
        square
        icon={isChecking ? <CircularProgress size={20} /> : <DollarSign />}
        color={profitabilityMode ? "primary" : "secondary"}
        onClick={handleProfitabilityMode}
        name={t(`views.editor.dialogs.project_settings.profitability.${profitabilityMode ? "off" : "on"}`)}
        tooltip
      />
      <FeatureAlert />
    </>
  )
})